import Layout from '../containers/Home';
import Auth from '../containers/Auth';
import Login from '../views/Auth';
import { Navigate } from 'react-router-dom';
import {
  DailyRating,
  Reports,
  Groups,
  TimeInterval,
  Search,
  Statistics,
  Map,
} from '../views/Governor';

import {
  SecretaryDailyRating,
  SecretaryDiagramma,
  SecretaryGroups,
  SecretaryTimeInterval,
  SecretaryWorks,
  SecretarySendedWorks,
} from '../views/GroupSecretary';

import Supervisor from '../views/Supervisor';
import SupervisorLeader from '../views/SupervisorLeader';

import Category from '../views/Admin/Category';
import Object from '../views/Admin/Object';

import Sections from '../views/Admin/Sections';
import Users from '../views/Admin/Users';
import Statistica from '../views/Admin/Statistica';
import Schedule from '../views/Governor/Schedule';
import FormCreator from '../components/FormCreator';
import Setting from '../views/Admin/Setting';
import Payments from 'views/Governor/Payments';
import SpecialTasks from 'views/Governor/SpecialTasks';
import Detail from 'views/Governor/SpecialTasks/Detail';
import Messages from 'views/Admin/Messages';

export const governorRoutes = [
  {
    element: <Layout />,
    children: [
      { path: '/', element: <Groups /> },
      { path: '/map', element: <Map /> },
      { path: '/detailed', element: <Groups /> },
      { path: '/daily-rating', element: <DailyRating /> },
      { path: '/time-interval', element: <TimeInterval /> },
      { path: '/reports', element: <Reports /> },
      { path: '/search', element: <Search /> },
      { path: '/statistics', element: <Statistics /> },
      { path: '*', element: <Navigate to='/' /> },
    ],
  },
  { path: '/login', index: true, element: <Login /> },
];
export const groupLeaderRoutes = [
  {
    element: <Layout />,
    children: [
      { path: '/', element: <Groups /> },
      { path: '/map', element: <Map /> },
      { path: '/detailed', element: <Groups /> },
      { path: '/daily-rating', element: <DailyRating /> },
      { path: '/time-interval', element: <TimeInterval /> },
      { path: '/reports', element: <Reports /> },
      { path: '/schedule', element: <Schedule /> },
      { path: '/payments', element: <Payments /> },
      { path: '/search', element: <Search /> },
      { path: '/statistics', element: <Statistics /> },
      { path: '/special-tasks', element: <SpecialTasks /> },
      { path: '/special-tasks/:id', element: <Detail /> },
      { path: '*', element: <Navigate to='/' /> },
    ],
  },
  { path: '/login', index: true, element: <Login /> },
];
export const groupSecretaryRoutes = [
  {
    element: <Layout />,
    children: [
      { path: '/', element: <SecretaryGroups /> },
      { path: '/daily-rating', element: <SecretaryDailyRating /> },
      { path: '/time-interval', element: <SecretaryTimeInterval /> },
      { path: '/new-works', element: <SecretaryWorks /> },
      { path: '/sent-works', element: <SecretarySendedWorks /> },
      { path: '/diagramma', element: <SecretaryDiagramma /> },
      { path: '*', element: <Navigate to='/' /> },
    ],
  },
  { path: '/login', index: true, element: <Login /> },
];
export const adminRoutes = [
  {
    element: <Layout />,
    children: [
      { path: '/', element: <Sections /> },
      { path: '/category', element: <Category /> },
      { path: '/object', element: <Object /> },
      { path: '/setting', element: <Setting /> },
      { path: '/add', element: <FormCreator /> },
      { path: '/users', element: <Users /> },
      { path: '/messages', element: <Messages /> },
      { path: '*', element: <Navigate to='/' /> },
    ],
  },
  { path: '/login', index: true, element: <Login /> },
];
export const supervisorRoutes = [
  {
    element: <Layout />,
    children: [
      { path: '/', element: <Supervisor /> },
      { path: '*', element: <Navigate to='/' /> },
    ],
  },
  { path: '/login', index: true, element: <Login /> },
];
export const supervisorLeaderRoutes = [
  {
    element: <Layout />,
    children: [
      { path: '/', element: <SupervisorLeader /> },
      { path: '*', element: <Navigate to='/' /> },
    ],
  },
  { path: '/login', index: true, element: <Login /> },
];

export const publicRoutes = [
  {
    element: <Auth />,
    children: [
      { path: '/login', index: true, element: <Login /> },
      { path: '*', element: <Navigate to='/login' /> },
    ],
  },
];
